export default __webpack_public_path__ + "static/media/route.70b18be0.svg";